export * from './CouponTemplate'
export * from './Coupon'

export enum CouponDiscountType {
  AMOUNT = 'AMOUNT',
  RATE = 'RATE',
}

export enum CouponDiscountCurrency {
  KRW = 'KRW',
  JPY = 'JPY',
}
